import * as React from 'react';
import { Create, Form, Toolbar } from 'react-admin';
import { CardContent } from '@mui/material';

import { SupplierInputs } from './SupplierInputs';

export const SupplierCreate = () => {
    return (
        <Create actions={false} redirect="show">
            <Form>
                <CardContent>
                    <SupplierInputs />
                </CardContent>
                <Toolbar />
            </Form>
        </Create>
    );
};
